
import { Outlet } from 'react-router-dom'
import { Page, PageHeader } from 'frame/components'
import { constants } from '../module'
import TabMenu from '../../../features/fleet/components/drill-down-modal/tab-menu'
import { useProfile } from 'features/account'

import Stack from '@mui/material/Stack'

const Account = () => {
  const profile = useProfile()

  const tabsConfig = [
    { label: 'Profile', path: constants.PATH_PROFILE },
  ]

  if ((profile?.sub || '').startsWith('auth0')) {
    tabsConfig.push({ label: 'Security', path: constants.PATH_SECURITY })
  }

  return (
    <Page
      title="Account"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        px: { xs: 3, md: 0 },
      }}>
      <Stack
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: '1280px'
        }}>
        <Stack sx={{ padding: '16px 0 32px 0' }}>
          <PageHeader title="Account" variant="h1" />
        </Stack>

        <TabMenu config={tabsConfig} />

        <Outlet />

      </Stack>
    </Page>
  )
}

export default Account
